// extracted by mini-css-extract-plugin
export default {"Radio":"ReviewMenu-module__Radio--YzJZU","RadioGroup":"ReviewMenu-module__RadioGroup--B2AAT","RadioText":"ReviewMenu-module__RadioText--wgW0k"};